var map = {
	"./bg-convite.webp": 1102,
	"./bg-deck-cards.webp": 1103,
	"./bg-dog-collar-preta.webp": 1104,
	"./bg-dog-collar.webp": 1105,
	"./bg-mesa-ampliado.webp": 1106,
	"./bg-mesa.webp": 1107,
	"./bg-parede.webp": 1108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1101;